export const computeClaimSum = (claims: any): string => {
  return claims.reduce((acc: number, val: any) => {
    return parseFloat(val.claimAmount) + parseFloat(acc);
  }, 0);
};
